import CartDiscountPriceMixin from '~/themes/cvb/mixins/CartDiscountPriceMixin'
import ProductBox from '~/themes/base/components/product/ProductBox'

export default {
  extends: ProductBox,
  mixins: [CartDiscountPriceMixin],
  props: {
    lazy: {
      type: Boolean,
      default: true,
    },
    highPriorityImage: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showDateOfStorage() {
      const delayDays = Number(this.product.availability.delayDays)
      return (
        this.$themeSettings.components.ProductBox.showDateOfStorage &&
        Number.isFinite(delayDays) &&
        delayDays > 0 &&
        delayDays < 21
      )
    },
  },
}
